import { call, put, takeLatest } from 'redux-saga/effects';
import { authApi } from '../services';

import {
  AUTH_REQUEST,
  AUTH_LOGOUT,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  AUTH_LOGOUT_SUCCESS,
  AUTH_FAILURE_UNAUTHORIZED,
} from '../reducers/auth.reducer';
import { handleError } from './helper';
import { USER_CURRENT_FETCH } from '../reducers/user.reducer';

function* authorize({ payload: { login, password } }) {
  try {
    let { token } = yield call(authApi.auth, { login, password });

    yield put({ type: AUTH_SUCCESS, payload: token });

    localStorage.setItem('token', token);
    yield put({ type: USER_CURRENT_FETCH });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: AUTH_FAILURE, payload: message });
  }
}

function authFailureHandle() {
  localStorage.removeItem('token');
}

function* logout() {
  yield put({ type: AUTH_LOGOUT_SUCCESS, payload: {} });
  localStorage.removeItem('token');
}

export function* loginRequest() {
  yield takeLatest(AUTH_REQUEST, authorize);
}

export function* logoutRequest() {
  yield takeLatest(AUTH_LOGOUT, logout);
}

export function* authFailure() {
  yield takeLatest(AUTH_FAILURE_UNAUTHORIZED, authFailureHandle);
}



// WEBPACK FOOTER //
// ./src/sagas/auth.saga.js